import React, { useState } from 'react';
import { useLanguage } from '../i18n/i18n';
import axios from 'axios';
import '../App.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const { t } = useLanguage();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('http://localhost:5000/send-message', formData);
      if (res.status === 200) {
        alert('Thank you for reaching out!');
      } else {
        alert('Something went wrong. Please try again.');
      }
      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      alert(`Failed to send message: ${err.response?.data?.message || err.message}`);
    }
  };

  return (
    <div className="contact-container">
        <div className="contact-form">
        <h2>{t('contact')}</h2>
        <form onSubmit={handleSubmit}>
            <label htmlFor="contact-name">{t('contactName')}</label>
            <input
            id="contact-name"
            type="text"
            name="name"
            placeholder={t('contactName')}
            value={formData.name}
            onChange={handleChange}
            required
            />
            <label htmlFor="contact-email">{t('contactEmail')}</label>
            <input
            id="contact-email"
            type="email"
            name="email"
            placeholder={t('contactEmail')}
            value={formData.email}
            onChange={handleChange}
            required
            />
            <label htmlFor="contact-message">{t('contactMessage')}</label>
            <textarea
            id="contact-message"
            name="message"
            placeholder={t('contactMessage')}
            value={formData.message}
            onChange={handleChange}
            required
            ></textarea>
            <button type="submit">{t('contactSend')}</button>
        </form>
        </div>
    </div>
  );
};

export default Contact;
